<div class="paybee-modal-header">
    <div class="modal-main-heading">{{modalMainHeadingText}}</div>
    <div class="modal-sub-heading">{{modalSubHeadingText}}</div>
</div>

<div class="mt-4" *ngIf="isLoginPage">
    <form [formGroup]="form">
        <div class="row justify-content-center">
            <div class="col-10">
                <div class="md-form form-sm inputCustom">
                    <input
                        formControlName="email"
                        type="email"
                        id="signInEmail"
                        [ngClass]="{
                            'form-control': true,
                            'invalid': form.get('email').dirty && form.get('email').invalid,
                            'valid': form.get('email').dirty && form.get('email').valid
                        }"
                        required
                        [email]="true"
                    >
                    <label
                        id="signInEmailLabel"
                        class="signInEmail"
                        for="signInEmail"
                        [attr.data-error]="getEMailErrorMessage()"
                    >Your email</label>
                </div>
                <div class="md-form form-sm inputCustom">
                    <input
                        formControlName="password"
                        type="password"
                        id="signInPassword"
                        [ngClass]="{
                            'form-control': true,
                            'invalid': form.get('password').dirty && form.get('password').invalid,
                            'valid': form.get('password').dirty && form.get('password').valid
                        }"
                        required
                    >
                    <label
                        id="signInPasswordLabel"
                        class="inputLabel"
                        for="signInPassword"
                        [attr.data-error]="getPasswordErrorMessage()"
                    >Your password</label>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="row justify-content-center w-100">
                <div class="col text-right">
                    <button (click)="onSubmit()" class="btn btn-md modal-confirm-button">Log In</button>
                </div>
            </div>
        </div>
        <div class="modal-footer" style="border-top: none">
            <div class="text-right pr-4">
                <p class="mb-1">Forgot <a class="blue-text" (click)="onForgotPassword()">Password?</a></p>
                <p>Don't have account <a class="blue-text" (click)="onSignUp()">Sign Up</a></p>
            </div>
        </div>
    </form>
</div>

<div class="mt-4" *ngIf="isSelectOrganizationPage">
    <form [formGroup]="form">
        <div class="modal-body">
            <div class="mx-3 mt-5">
                <app-jquery-select-control
                    formControlName="organization"
                    [list]="organizations"
                    label="Select Organization"
                ></app-jquery-select-control>
            </div>
        </div>
        <div class="modal-footer" style="border-top: none">
            <div class="text-center mt-2 mb-2">
                <button class="btn btn-md modal-confirm-button" (click)="onSelectOrganization()">{{loginAs}}</button>
            </div>
        </div>
    </form>
</div>
